import { useMemo } from 'react';

import useMatch from '../MatchUnit/useMatch';
import useMatchHighlight from '../MatchUnit/useMatchHighlight';

import type { Match } from '@shared-types/match.types';
import { MatchStatus } from '@shared-types/match.types';
import { language } from '@utilities/browser';

export const useMatchStream = (originalMatch: Match, showMatchHighlights = false) => {
  const match = useMatch(originalMatch);
  const stream = useMemo(() => match.streamUrl?.[language.toUpperCase()], [match.streamUrl]);

  const isDomestic = match.competition?.region === 'DOMESTIC';
  const highlightsVideo = useMatchHighlight(
    match,
    !isDomestic && showMatchHighlights && match.status === MatchStatus.FINISHED,
  );

  const youTubeId = useMemo(() => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const check = regExp.exec(stream);
    return check && check[7].length === 11 ? check[7] : null;
  }, [stream]);

  return { stream, youTubeId, highlightsVideo };
};
